export type StoneColor = "neutral" | "player1" | "player2";

export type Cell = StoneColor[];

/** 4x4 grid where each cell is a stack of stones (bottom-to-top) */
export type Board = Cell[][];

export type Direction = "up" | "down" | "left" | "right";

export interface QawaleMove {
  row: number;
  col: number;
  direction: Direction;
}

export interface ParsedMove {
  seq: number;
  author: string;
  move: unknown;
  eventId: string;
  createdAt: number;
}

export type GameStatus = "open" | "active" | "complete" | "cancelled";

export interface GameMeta {
  gameId: string;
  gameType: string; // e.g. "qawale", "chess"
  creator: string;
  opponent?: string;
  betAmount: number;
  mintUrl: string;
  status: GameStatus;
  escrowPubkey: string;
  creatorProofs?: string; // encoded cashu token
  opponentProofs?: string;
  encryptedEscrowPrivkey?: string; // NIP-44 encrypted to opponent
  winner?: string;
  moveTimeoutSeconds?: number; // per-move time limit (e.g. 300 = 5min)
  aiDifficulty?: string; // "easy" | "medium" | "hard" — set when opponent is AI bot
}

export interface GameState {
  meta: GameMeta;
  board: unknown;
  moves: ParsedMove[];
  currentTurn: "player1" | "player2";
  winner: "player1" | "player2" | null;
  winningCells: [number, number][] | null;
  isDraw: boolean;
  isComplete: boolean;
  lastMoveTimestamp?: number;
  /** Game-engine-specific state (e.g. QawaleEngineState, ChessEngineState) */
  engineState: unknown;
  /** Whether the pie rule swap was invoked (roles flipped) */
  swapped: boolean;
  /** Effective pubkey for Blue (player1), accounting for swap */
  player1Pubkey: string;
  /** Effective pubkey for Orange (player2), accounting for swap */
  player2Pubkey?: string;
  /** True when Player 2 can choose to swap (pie rule window open) */
  piePhase: boolean;
  /** True if a player resigned */
  resigned: boolean;
}

export const GAME_KIND = 30069;
export const MOVE_KIND = 1069;
export const SIDE_BET_KIND = 31070;
export const SIDE_BET_TAKE_KIND = 1071;
export const STONES_PER_PLAYER = 8;
export const BOARD_SIZE = 4;

export type SideBetStatus = "open" | "matched" | "settled" | "cancelled";

export interface SideBetOffer {
  betId: string;
  offerer: string;
  gameAddress: string;
  side: "player1" | "player2";
  amount: number;
  mintUrl: string;
  escrowPubkey: string;
  offerorProofs: string;
  status: SideBetStatus;
  taker?: string;
  takerProofs?: string;
  encryptedEscrowPrivkey?: string;
}

export interface SideBetTake {
  eventId: string;
  offerId: string;
  taker: string;
  takerProofs: string;
}
